<template>
    <div class="conversionred" v-loading="loading">
        <div class="conversionred-first">
            <div class="conversionred-first-top">
                <div class="conversionred-first-top-left">兑换红包活动设置</div>
                <div class="conversionred-first-top-right" @click="refresh">刷新</div>
            </div>

            <div class="conversionred-first-table">
                <el-table :data="firstTable" border style="width: 100%; cursor: pointer" :header-cell-style="{
                    color: '#333333',
                    backgroundColor: '#FAFAFA',
                }">
                    <el-table-column label="规则说明">
                        <template slot-scope="scope">
                            <div class="table-rule" v-html="scope.row.detail"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否启用" width="110">
                        <template slot-scope="scope">
                            <div class="table-status">
                                <el-switch :value="coronaStatus" active-color="#13ce66" inactive-color="#D9D9D9"
                                    @change="switchChange(scope.row.status)"></el-switch>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="110">
                        <template slot-scope="scope">
                            <div class="table-operate" @click="redactBtn(scope.row)">
                                编辑
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <div class="conversionred-second">
            <div class="conversionred-second-top">
                <div class="conversionred-second-top-title">兑换红包奖品设置</div>
                <div class="conversionred-second-top-addition" @click="addBtn">
                    <img class="addition-img" src="../../assets/common/common-add.png" />
                    <div class="addition-text">添加</div>
                </div>
            </div>
            <div class="conversionred-second-table">
                <el-table :data="tableData" border style="width: 100%; cursor: pointer" :header-cell-style="{
                    color: '#333333',
                    backgroundColor: '#FAFAFA',
                }">
                    <el-table-column prop="redName" label="红包名称"></el-table-column>
                    <el-table-column label="红包面值(元)">
                        <template slot-scope="scope">
                            <span>¥ &nbsp; {{ scope.row.price }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="红包兑换所需积分">
                        <template slot-scope="scope">
                            <span>{{ scope.row.integral }} &nbsp; 积分</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="ID兑换限制次数">
                        <template slot-scope="scope">
                            <span>{{ scope.row.num }} &nbsp; 次</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="134">
                        <template slot-scope="scope">
                            <div class="table-operation">
                                <div class="table-operation-left" @click="redOperation(scope.row)">
                                    编辑
                                </div>
                                <div class="table-operation-right" @click="redDetele(scope.row)">
                                    删除
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!--switch状态开启关闭-->
        <div class="switch">
            <el-dialog :visible.sync="switchDialogVisible" width="394px" style="margin-top: 10vh" @close="switchClose">
                <span slot="footer" class="dialog-footer">
                    <div class="switch-div">
                        <img class="switch-div-img" src="../../assets/common/common-warning.png" />
                        <div class="switch-div-title">
                            {{
                                coronaStatus == false
                                ? '是否确定启用该积分兑换红包活动？'
                                : '是否确定禁用该积分兑换红包活动？'
                            }}
                        </div>
                        <div class="switch-div-text">
                            {{
                                coronaStatus == false
                                ? '一旦启用成功则用户可参与此活动。'
                                : '一旦禁用成功则用户不可参与此活动。'
                            }}
                        </div>
                        <div class="switch-div-button">
                            <div class="switch-div-button-left" @click="swicthBtn">确定</div>
                            <div class="switch-div-button-right" @click="switchClose">
                                取消
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--第一区域规则 编辑-->
        <div class="rule">
            <el-dialog :visible.sync="ruleDialogVisible" width="444px" style="margin-top: 10vh" @close="ruleCancel">
                <span slot="footer" class="dialog-footer">
                    <div class="rule-block">
                        <div class="rule-block-top">
                            <div class="rule-block-top-title">编辑</div>
                            <img class="rule-block-top-close" src="../../assets/common/close.png" @click="ruleCancel" />
                        </div>

                        <div class="rule-block-textarea">
                            <div class="rule-block-textarea-title">规则说明</div>

                            <el-input type="textarea" placeholder="请输入规则说明" v-model="ruleTextarea" maxlength=""
                                show-word-limit></el-input>
                        </div>

                        <div class="rule-block-button">
                            <!-- <div class="rule-block-button-left" @click="ruleCancel">
                取 消
              </div> -->
                            <div class="rule-block-button-right" @click="ruleConfirm">
                                确 定
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--第二区域添加 弹出框-->
        <div class="addBlock">
            <el-dialog :visible.sync="addDialogVisible" width="444px" style="margin-top: 10vh" @close="addClose">
                <span slot="footer" class="dialog-footer">
                    <div class="addBlock-div">
                        <div class="addBlock-div-top">
                            <div class="addBlock-div-top-title">添加</div>
                            <img class="addBlock-div-top-close" src="../../assets/common/close.png" @click="addClose" />
                        </div>
                        <div class="addBlock-div-center">
                            <div class="center-header">
                                <div class="center-header-title">红包名称</div>
                                <div class="center-header-input">
                                    <el-input placeholder="请输入红包名称" v-model="addredName" clearable></el-input>
                                </div>
                            </div>

                            <div class="center-display">
                                <div class="center-display-left">
                                    <div class="center-display-left-title">红包面值</div>
                                    <div class="center-display-left-input">
                                        <el-input placeholder="请输入红包面值" v-model="addRednominal" class="input-with-select">
                                            <div class="input-append" slot="append">元</div>
                                        </el-input>
                                    </div>
                                </div>
                                <div class="center-display-right">
                                    <div class="center-display-right-title">红包兑换所需积分</div>
                                    <div class="center-display-right-input">
                                        <el-input placeholder="请输入所需积分" v-model="addNeededintegral"
                                            class="input-with-select"></el-input>
                                    </div>
                                </div>
                            </div>


                            <div class="center-display">
                                <div class="center-display-left">
                                    <div class="center-display-left-title">ID限制兑换次数</div>
                                    <div class="center-display-left-input">
                                        <el-input placeholder="请输入ID限制兑换次数" v-model="addredNum" class="input-with-select">
                                        </el-input>
                                    </div>
                                </div>
                                <div class="center-display-right">
                                    <div class="center-display-right-title">红包排序</div>
                                    <div class="center-display-right-input">
                                        <el-input placeholder="请输入排序号" v-model="addSort"
                                            class="input-with-select"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="addBlock-div-button">
                            <!-- <div class="addBlock-div-button-left" @click="addClose">
                重 置
              </div> -->
                            <div class="addBlock-div-button-right" @click="addConfirm">
                                确 定
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--第三区域删除 弹出框-->
        <div class="detele">
            <el-dialog :visible.sync="deteleDialogVisible" width="394px" style="margin-top: 10vh" @close="cancelDetele">
                <span slot="footer" class="dialog-footer">
                    <div class="detele-div">
                        <img class="detele-div-img" src="../../assets/common/common-warning.png" />
                        <div class="detele-div-title">是否确定删除该红包兑换选项</div>
                        <div class="detele-div-button">
                            <div class="detele-div-button-left" @click="confirmDetele">
                                确定
                            </div>
                            <div class="detele-div-button-right" @click="cancelDetele">
                                取消
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getred,
    putredDisable,
    postredruleCompile,
    postredAdd,
    deletefnredDetails,
} from '../../api/activities'

export default {
    comments() { },
    data() {
        return {
            /* 第一区域 */
            // 是否启动大轮盘开关  false 关闭状态 true 开启状态
            coronaStatus: false,
            // 兑换红包活动设置 第一区域表格
            firstTable: [],

            /* 第二块区域 */
            // switch状态栏修改
            switchDialogVisible: false,
            // 展开table表格数组
            tableData: [],

            /* 左侧弹出框 */
            // 规则编写弹出框
            ruleDialogVisible: false,
            // 骨子额填写字符串
            ruleTextarea: '',

            /*end */

            /* 右侧弹出框 */
            // 添加 弹出框  是否开启
            addDialogVisible: false,
            // 添加 红包名称
            addredName: '',
            // 添加  输入红包面值
            addRednominal: '',
            // 添加  所需积分
            addNeededintegral: '',
            // 添加  次数
            addredNum: '',
            // 添加或者编辑是否有id
            addId: '',
            // 添加或者编辑是否有排序
            addSort: '',
            /* end */

            /* 删除弹出框 */
            deteleDialogVisible: false,
            // 监听用户刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            activeiesFunShow: false,
        }
    },
    created() {
        // 请求兑换红包设置接口
        this.loading = true
        this.getredport()

        setTimeout(() => {
            this.activeiesFunShow = this.$store.state.pageFunctionShow

        }, 1000);

    },
    methods: {
        // 获取兑换红包管理基本数据
        getredport() {
            let params = {}

            getred(params).then((res) => {
                console.log('获取red红包数据', res)
                if (res.resultStatus == true) {
                    let Obj = res.resultData
                    this.coronaStatus = Obj.status == 0 ? false : true
                    // 获取第一区域表格数据
                    this.firstTable = []
                    this.firstTable.push(Obj)
                    // 获取第二区域表格数据
                    this.tableData = Obj.redList

                    this.loading = false
                }
            })
        },

        // 监听switch关闭
        switchChange(e) {
            if (this.activeiesFunShow == false) {
                return
            }
            this.switchDialogVisible = true
        },
        // 监听switch的状态切换 确认
        swicthBtn() {
            let params = {}
            // 切换是否开启或者禁用
            putredDisable(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: this.coronaStatus == false ? '启动成功' : '禁用成功',
                        type: 'success',
                    })

                    this.coronaStatus = !this.coronaStatus
                    this.switchDialogVisible = false
                }
            })
        },
        // 监听switch的状态切换 取消
        switchClose() {
            this.switchDialogVisible = false
        },

        /* 左侧编辑按钮 */
        // 左侧点击按钮
        redactBtn(item) {
            if (this.activeiesFunShow == false) {
                return
            }

            this.ruleTextarea = item.detail
            this.ruleDialogVisible = true
        },
        // 左侧规格填写  取消按钮
        ruleCancel() {
            this.ruleTextarea = ''
            this.ruleDialogVisible = false
        },
        // 左侧规格填写  确定按钮
        ruleConfirm() {
            let params = {
                detail: this.ruleTextarea,
            }

            postredruleCompile(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                    })

                    this.ruleDialogVisible = false
                    this.getredport()
                }
            })
        },

        /* end */

        /* 右侧编辑按钮 */
        // 添加按钮
        addBtn() {
            if (this.activeiesFunShow == false) {
                return
            }
            this.addDialogVisible = true
        },
        // 添加按钮 蒙层  重置
        addClose() {
            // 清空输入框内部数据
            this.addredName = '' // 请输入红包名称
            this.addRednominal = '' // 请输入红包面值
            this.addNeededintegral = '' // 请输入所需积分
            this.addredNum = '' // 请输入ID限制兑换次数
            this.addId = '' // 请输入id
            this.addSort = '' // 请输入Sort

            this.addDialogVisible = false
        },

        // 添加按钮 确认
        addConfirm() {
            // 用户点击确定
            // 编辑
            let params = {
                id: this.addId,
                redName: this.addredName,
                redImage: '',
                price: this.addRednominal,
                integral: this.addNeededintegral,
                sort: this.addSort,
                num: this.addredNum,
            }

            postredAdd(params).then((res) => {
                if (res.resultStatus == true) {
                    this.loading = true
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                    })
                    this.addClose()
                    this.getredport()
                }
            })
        },

        /* end */

        /* 删除 */
        // 开启删除弹出框
        redDetele(item) {
            if (this.activeiesFunShow == false) {
                return
            }
            this.addId = item.id // 当前兑换的id
            this.deteleDialogVisible = true
        },

        // 确定删除框
        confirmDetele() {
            // 点击删除
            let params = this.addId
            deletefnredDetails(params).then((res) => {
                if (res.resultStatus == true) {
                    this.loading = true
                    this.$message({
                        message: '删除成功',
                        type: 'success',
                    })
                    this.addClose()
                    this.getredport()
                    this.deteleDialogVisible = false
                }
            })
        },

        // 取消删除弹出框
        cancelDetele() {
            this.deteleDialogVisible = false
        },

        /* end */
        // 编辑按钮
        redOperation(item) {
            if (this.activeiesFunShow == false) {
                return
            }

            this.addredName = item.redName // 请输入红包名称
            this.addRednominal = item.price // 请输入红包面值
            this.addNeededintegral = item.integral // 请输入所需积分
            this.addredNum = item.num // 请输入ID限制兑换次数
            this.addId = item.id // 当前兑换的id
            this.addSort = item.sort // 当前兑换的排序

            this.$nextTick(() => {
                this.addDialogVisible = true
            })
        },
        // 用户点击界面刷新
        refresh() {
            this.loading = true

            this.$nextTick(() => {
                this.getredport()
            })
        },
    },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

.conversionred {
    width: 100%;

    .conversionred-first {
        height: 210px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 0 24px;
        box-sizing: border-box;

        .conversionred-first-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 68px;

            .conversionred-first-top-left {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .conversionred-first-top-right {
                width: 70px;
                height: 36px;
                border-radius: 10px;
                border: 1px solid rgba(34, 34, 34, 0.4);
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #222222;
                text-align: center;
                line-height: 36px;
                cursor: pointer;
            }
        }

        .conversionred-first-table {
            /deep/ .el-table thead {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
                background: #d8d8d8;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            .table-rule {
                word-break: break-all;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .table-status {
                width: 42px;

                /deep/ .el-switch__core {
                    width: 42px !important;
                }
            }

            .table-operate {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #2aa4ff;
                text-decoration: underline;
            }
        }
    }

    .conversionred-second {
        margin-top: 24px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 0 24px 24px;
        box-sizing: border-box;

        .conversionred-second-top {
            height: 68px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .conversionred-second-top-title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #222222;
            }

            .conversionred-second-top-addition {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 82px;
                height: 36px;
                background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                border-radius: 10px;
                cursor: pointer;

                .addition-img {
                    width: 13px;
                    height: 13px;
                }

                .addition-text {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    margin-left: 8px;
                }
            }
        }

        .conversionred-second-table {
            /deep/ .el-table .el-table__cell {
                padding: 13px 0;
            }

            /deep/ .el-table thead {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
                background: #d8d8d8;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            .table-operation {
                display: flex;

                .table-operation-left,
                .table-operation-right {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2aa4ff;
                    text-decoration: underline;
                }

                .table-operation-right {
                    margin-left: 24px;
                }
            }
        }
    }

    /* 弹出框样式 */
    .switch {
        /deep/ .el-dialog {
            height: 231px;
        }

        /deep/ .el-dialog__footer {
            padding: 25px 0;
            box-sizing: border-box;
        }

        .switch-div {
            width: 100%;
            text-align: center;

            .switch-div-img {
                width: 56px;
                height: 56px;
                margin: 0 auto;
            }

            .switch-div-title {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                margin-top: 8px;
            }

            .switch-div-text {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                margin-top: 2px;
            }

            .switch-div-button {
                display: flex;
                justify-content: center;
                align-content: center;
                margin-top: 18px;

                .switch-div-button-left,
                .switch-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    cursor: pointer;
                }

                .switch-div-button-right {
                    margin-left: 8px;
                    border: 1px solid #e9edf4;
                    color: rgba(0, 0, 0, 0.65);
                    background: #ffffff;
                }
            }
        }
    }

    /* 填写规则弹出框 */
    .rule {
        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        /deep/ .el-dialog {
            height: 320px;
            border-radius: 10px !important;
        }

        .rule-block {
            .rule-block-top {
                display: flex;
                height: 56px;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #e9edf4;

                .rule-block-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #222222;
                }

                .rule-block-top-close {
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                }
            }

            .rule-block-textarea {
                padding: 22px 24px;
                box-sizing: border-box;
                background: #ffffff;
                border-radius: 5px;

                .rule-block-textarea-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                /deep/ .el-textarea {
                    height: 152px;
                    cursor: pointer;
                }

                /deep/ .el-textarea__inner {
                    height: 152px;
                    padding: 10px 10px 20px;
                }

                /deep/ .el-textarea .el-textarea__inner {
                    // 然后找到对应的类名，在这里将拉伸去掉即可
                    resize: none;
                }
            }

            .rule-block-button {
                display: flex;
                justify-content: flex-end;
                padding: 0 24px;
                box-sizing: border-box;
                border-top: 1px solid #e9edf4;
                height: 52px;
                align-items: center;

                .rule-block-button-left,
                .rule-block-button-right {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    cursor: pointer;
                }

                .rule-block-button-right {
                    margin-left: 8px;
                    color: #ffffff;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                }
            }
        }
    }

    /* 右侧添加弹出框 */
    .addBlock {
        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        /deep/ .el-dialog {
            height: 330px;
            border-radius: 10px !important;
        }

        .addBlock-div {
            .addBlock-div-top {
                display: flex;
                height: 56px;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #e9edf4;

                .addBlock-div-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #222222;
                }

                .addBlock-div-top-close {
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                }
            }

            .addBlock-div-center {
                padding: 20px 24px 21px;
                box-sizing: border-box;

                .center-header {
                    .center-header-title {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                    }

                    .center-header-input {
                        height: 32px;
                        background: #ffffff;
                        border-radius: 5px;
                        margin-top: 4px;

                        /deep/ .el-input {
                            height: 32px;
                        }

                        /deep/ .el-input__inner {
                            padding: 0 10px;
                            box-sizing: border-box;
                            height: 32px;
                            background-color: rgba(255, 255, 255, 0);
                        }
                    }
                }

                .center-display {
                    display: flex;
                    margin-top: 14px;
                    align-items: center;

                    .center-display-left,
                    .center-display-right {
                        width: 50%;
                        text-align: left;


                        .center-display-left-title,
                        .center-display-right-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .center-display-left-input,
                        .center-display-right-input {
                            margin-top: 4px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-input-group__append {
                                background-color: #ffffff;
                                height: 32px;
                                padding: 0;
                            }

                            .input-append {
                                width: 38px;
                                height: 30px;
                                background: #ffffff;
                                border-radius: 0px 5px 5px 0px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #555555;
                            }
                        }
                    }

                    .center-display-right {
                        margin-left: 36px;
                    }
                }

                .center-conversion {
                    margin-top: 14px;

                    .conversion-title {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                    }

                    .conversion-input {
                        width: 180px;

                        /deep/ .el-input {
                            height: 32px;
                        }

                        /deep/ .el-input__inner {
                            padding: 0 10px;
                            box-sizing: border-box;
                            height: 32px;
                            background-color: rgba(255, 255, 255, 0);
                        }
                    }
                }
            }

            .addBlock-div-button {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 0 24px;
                box-sizing: border-box;
                height: 52px;
                border-top: 1px solid #e9edf4;

                .addBlock-div-button-left,
                .addBlock-div-button-right {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }

                .addBlock-div-button-right {
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    margin-left: 8px;
                    color: #ffffff;
                }
            }
        }
    }

    /* 右侧删除弹出框 */
    .detele {
        /deep/ .el-dialog {
            height: 231px;
        }

        /deep/ .el-dialog__footer {
            padding: 25px 0;
            box-sizing: border-box;
        }

        .detele-div {
            width: 100%;
            text-align: center;

            .detele-div-img {
                width: 56px;
                height: 56px;
                margin: 0 auto;
            }

            .detele-div-title {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                margin-top: 8px;
            }

            .detele-div-button {
                display: flex;
                justify-content: center;
                align-content: center;
                margin-top: 40px;

                .detele-div-button-left,
                .detele-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    cursor: pointer;
                }

                .detele-div-button-right {
                    margin-left: 8px;
                    border: 1px solid #e9edf4;
                    color: rgba(0, 0, 0, 0.65);
                    background: #ffffff;
                }
            }
        }
    }
}
</style>
